import type { TableSemanticSchema } from './types';

export const EisenhowerSchema: TableSemanticSchema = {
  id: 'eisenhower',
  name: 'Eisenhower Matrix',
  description:
    'Urgency vs. importance 2×2. Action field auto-derives from quadrant: do / schedule / delegate / eliminate.',
  cells: [
    { id: 'do', label: 'Urgent & Important — Do', row: 0, col: 0, accent: '#dc2626' },
    { id: 'schedule', label: 'Important, Not Urgent — Schedule', row: 0, col: 1, accent: '#2563eb' },
    { id: 'delegate', label: 'Urgent, Not Important — Delegate', row: 1, col: 0, accent: '#f59e0b' },
    { id: 'eliminate', label: 'Neither — Eliminate', row: 1, col: 1, accent: '#64748b' },
  ],
  itemFields: [
    { key: 'urgency', label: 'Urgency', kind: 'enum', required: true,
      options: [
        { value: 'high', label: 'High' },
        { value: 'low', label: 'Low' },
      ] },
    { key: 'importance', label: 'Importance', kind: 'enum', required: true,
      options: [
        { value: 'high', label: 'High' },
        { value: 'low', label: 'Low' },
      ] },
    { key: 'action', label: 'Action', kind: 'enum',
      options: [
        { value: 'do', label: 'Do' },
        { value: 'schedule', label: 'Schedule' },
        { value: 'delegate', label: 'Delegate' },
        { value: 'eliminate', label: 'Eliminate' },
      ] },
  ],
  renderingHints: { layout: 'quadrant' },
};
